import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DataService } from 'src/app/shared/data.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-verify-email',
    templateUrl: './verify-email.component.html',
    styleUrls: ['./verify-email.component.scss'],
    standalone: false
})
export class VerifyEmailComponent implements OnInit {
  token: any;

  constructor(public router: Router, private route: ActivatedRoute, private dataService: DataService, private dialog: MatDialog) {
   }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
    this.verifyEmail();
  }

  verifyEmail() {
    this.dataService.post(`auth/VerifyEmail/${this.token}`, null).then((data: any) => {
      if (data.statusCode === 200) {
        this.router.navigate(['/']);
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Your email has been verified successfully please wait for admin approval, thank you!',
            buttonText: 'Ok'
          }
        });
      } else {
        this.router.navigate(['/']);
      }
    });
  }

}
